export const filterMetricsForTotals = ({
  usedMetrics,
  chartDef,
}: {
  usedMetrics: Metrics.Metric[];
  chartDef: V5ChartDefinition;
}): Metrics.Metric[] => {
  const disabledIds = new Set(
    chartDef.series
      .filter((s) => s.isTotalEnabled === false)
      .map((s) => s.metricId),
  );
  if (disabledIds.size === 0) return usedMetrics;
  return usedMetrics.filter((m) => !disabledIds.has(m.id));
};
